export const MODULE_NAMES = {
  HOME: "Home",
  EXPLORE: "Explore",
  CALCULATE: "Calculate",
  MONITOR: "Monitor",
  ADVISORY: "Advisory",
  KILIMOBOT: "KilimoBot",
  ADMIN: "Admin",
};

export const SCREEN_TO_MODULE = {
  dashboard: MODULE_NAMES.HOME,
  cropSuitability: MODULE_NAMES.CALCULATE,
  risk: MODULE_NAMES.CALCULATE,
  monitor: MODULE_NAMES.MONITOR,
  advisory: MODULE_NAMES.ADVISORY,
  admin: MODULE_NAMES.ADMIN,
};

/**
 * Returns true if the user has Read access to the given module.
 * Returns true when permissions haven't loaded yet (null) to avoid flash.
 */
export function canRead(permissions, moduleName) {
  if (permissions === null) return true;
  const perms = permissions[moduleName];
  if (!perms) return false;
  return perms.includes("Read");
}

/**
 * Returns true if the user has Write access to the given module.
 * Returns true when permissions haven't loaded yet (null) to avoid flash.
 */
export function canWrite(permissions, moduleName) {
  if (permissions === null) return true;
  const perms = permissions[moduleName];
  if (!perms) return false;
  return perms.includes("Write");
}

const SCREEN_PRIORITY = ["dashboard", "cropSuitability", "monitor", "advisory"];

/**
 * Returns the first screen the user has Read access to, or null if none.
 */
export function getFirstAvailableScreen(permissions) {
  if (permissions === null) return "dashboard";
  for (const screen of SCREEN_PRIORITY) {
    const mod = SCREEN_TO_MODULE[screen];
    if (canRead(permissions, mod)) return screen;
  }
  return null;
}
